export default "__VITE_ASSET__CPGBwtaF__"